import React, { Component } from 'react';
import { CSSTransition } from 'react-transition-group';

import './SplashScreen.css';

function displayMessage(display, done, onEntered, onExited) {
    return done ? null : (
        <CSSTransition in={display} timeout={1000} classNames="splash-screen-content" onEntered={onEntered} onExited={onExited}>
            <div>
                <div className="splash-screen">
                    <img src="/img/WebMD-TV-Knock-out_Horizontal.svg" />
                    <CSSTransition in={true} timeout={200} classNames="splash-screen-content-heading">
                        <div>
                            <div className="splash-screen-heading">Welcome! Please wait while we load your experience...</div>
                        </div>
                    </CSSTransition>
                    <div className="loading-dot">.</div>
                </div>
            </div>
        </CSSTransition>
    );
}

function SplashScreen(WrappedComponent) {
    return class extends Component {
        constructor(props) {
            super(props);
            this.state = {};

            this.onEntered = this.onEntered.bind(this);
            this.onExited = this.onExited.bind(this);
        }

        onEntered() {
            console.log("entered");
            this.setState({
                displayed: true
            });
        }

        onExited() {
            console.log("exited");
            this.setState({
                done: true
            });
        }

        componentDidMount() {
            this.display();
        }

        componentDidUpdate(prevProps) {
            var prevCampaignId = prevProps.campaignId;
            var campaignId = this.props.campaignId;

            if (prevCampaignId && campaignId && (prevCampaignId !== campaignId))
                this.display();
        }

        display() {
            this.setState({
                display: true,
                displayed: false,
                done: false
            });

            setTimeout(() => {
                this.setState({
                    display: false
                });
            }, 3000)
        }

        render() {
            return <div>
                {
                    this.state.done || this.state.displayed ?
                        <WrappedComponent {...this.props} hide={!this.state.done} />
                    : null
                }
                {
                    displayMessage(this.state.display, this.state.done, this.onEntered, this.onExited)
                }
                </div>;
        }
    };
}

export default SplashScreen;